import { render } from "./BasicTimeline.vue?vue&type=template&id=c4422fc6&ts=true"
import script from "./BasicTimeline.vue?vue&type=script&lang=ts"
export * from "./BasicTimeline.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__